import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { Expensable } from 'modules/expenses/types/Expensable'

export const buildMileageData = (expensable: Expensable) => {
  const from = expensable?.mileage?.from
  const to = expensable?.mileage?.to
  const roundTrip = expensable?.mileage?.roundTrip
  const stops = expensable?.mileage?.mileageStops ?? []

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.from'),
      info: from,
    },
    ...[...stops]
      .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
      .filter((stop) => stop.name)
      .map((stop, index) => ({
        title: `${i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.stop')} ${index + 1}`,
        info: stop.name,
      })),
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.to'),
      info: to,
    },
    {
      //TODO: Adapt based on product decision
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.round_trip'),
      info: roundTrip ? i18n.t('common.yes') : i18n.t('common.no'),
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
